import React from 'react';
export default function ChildrenWrapper(props) {
    return <>{props.children}</>;
}
//# sourceMappingURL=ChildrenWrapper.js.map